const formatHexColor = (color) =>
  !!color ? (color.startsWith('#') ? color : `#${color}`) : color;

export default formatHexColor;
